import { useMutation, useQueryClient } from '@tanstack/react-query';
import axios from 'util/Api'

export const PostUserSearchHistory = async (data) => {
	
	let url = `/users/searchHistory`;

  const jwt =  JSON.parse(localStorage.token);

	const results = await axios
		.post(url, data, {headers: { 'Authorization':`Bearer ${jwt}`}})
		.then((response) => response.data);
	return results;
};


export const usePostUserSearchHistory = () => {
	const client = useQueryClient();

	const mutation = useMutation({
		mutationFn: PostUserSearchHistory,
		onSuccess: (successData) => {
			client.invalidateQueries({
				queryKey: ['getUserSearchHistory'],
			});
		},
	});
	return mutation;
};

export default usePostUserSearchHistory;